import { color } from "@/styles/theme";
import { ReactNode } from "react";

export const Box = (props: { children?: ReactNode }) => {
  return (
    <div
      css={{
        border: `solid 1px ${color.gray300}`,
        borderRadius: "4px",

        width: "100%",
        maxWidth: 1200,
      }}
      {...props}
    >
      {props.children}
    </div>
  );
};
